<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ $t("finance_request_refund_title") }}</v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <text-field
            v-model.number="form.orderId"
            :label="$t('finance_order_id_label')"
            type="number"
            prependInnerIcon="mdi-pound"
            :rules="[rules.required, rules.positive]"
          />
          <text-field
            v-model="form.orderRef"
            :label="$t('finance_order_description_optional')"
            prependInnerIcon="mdi-text-box-outline"
          />
          <text-field
            v-model="form.customer"
            :label="$t('finance_customer')"
            kind="user"
            :rules="[rules.required]"
          />
          <text-field
            v-model="form.reason"
            :label="$t('finance_reason')"
            prependInnerIcon="mdi-message-alert-outline"
            :rules="[rules.required]"
          />
          <text-field
            v-model.number="form.amount"
            :label="$t('finance_amount_currency', { currency: restaurantCurrency })"
            type="number"
            :suffix="restaurantCurrency"
            :rules="[rules.required, rules.positive]"
          />
          <payment-method-dropdown
            v-model="form.method"
            :label="$t('finance_refund_method_optional')"
            clearable
          />
          <text-area
            v-model="form.comment"
            :label="$t('finance_comment_optional')"
            rows="2"
          />
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">{{ $t("finance_cancel") }}</v-btn>
        <primary-button :loading="saving" @click="submit">{{ $t("finance_save") }}</primary-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import PaymentMethodDropdown from "../fields/PaymentMethodDropdown.vue";

const emptyForm = () => ({
  orderId: null,
  orderRef: "",
  customer: "",
  reason: "",
  amount: 0,
  method: "",
  comment: "",
});

export default {
  name: "RefundFormDialog",

  components: { PaymentMethodDropdown },

  props: {
    value: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
  },

  data() {
    return {
      valid: true,
      form: emptyForm(),
      rules: {
        required: (v) => (v !== null && v !== undefined && v !== "") || this.$t("finance_required_field"),
        positive: (v) => Number(v) > 0 || this.$t("finance_amount_must_be_positive"),
      },
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value(isOpen) {
      if (!isOpen) return;
      this.form = emptyForm();
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
    },
  },

  methods: {
    close() {
      this.$emit("input", false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("save", {
        // order_id (backend odgovor 16.09.2026 §3.3) - mora postojati u
        // orders_guest, sad je stvarni identifikator (ranije se ID vadio
        // regexom iz order_ref, davalo pogrešne vrijednosti). order_ref
        // ostaje kao slobodan tekstualni opis, više nije obavezan.
        order_id: Number(this.form.orderId),
        order_ref: this.form.orderRef || undefined,
        customer: this.form.customer,
        reason: this.form.reason,
        amount: Number(this.form.amount),
        method: this.form.method || undefined,
        comment: this.form.comment || undefined,
      });
    },
  },
};
</script>
